export default {
  state: {
    // эта часть относится к Mode
    satzes: [],
    // эта часть относится к Regime 
    idMode0 : null, // Regime     
    //-----------------------
    doNext: null, // doNext - флаг что делать по кнопке NEXT
    isFirstAnswer: true,    
    modeK: 1.0,
    isToRepeat: false,
    isToCheckVerb: false,
    //-----------------------    
    //текущий прогресс по idMode и idMode0 т.е. Regime
    progressMode : [],   
    satz: {},
    tipp: {
      idSatz: null,
      tippMain: null,
      tippSatz: null,
      tippWords: [],
      tippVerbs: []
    },
    verify_result: {
      idSatz: null,
      result: null,
      verbsUnknown: [],
      resultWordsAnswerPerson: [],
      resultWordsAnswerRight: [],
      resultVerbsPlaceAnswerRight: []
    },
    audio_recognize: {
      idSatz: null,
      result: null,
    }    
  },
  getters: {
    satzes(state) {
      return state.satzes
    },
    idMode0(state) {
      return state.idMode0
    },
    //-----------------------------------
    doNext(state){
      return state.doNext
    },
    isFirstAnswer(state){
      return state.isFirstAnswer
    },    
    modeK(state){
      return state.modeK
    },    
    isToRepeat(state){
      return state.isToRepeat
    },
    isToCheckVerb(state){
      return state.isToCheckVerb
    },
    //-----------------------------------
    progressMode(state){
      return state.progressMode
    },
    satz(state) {
      return state.satz
    },
    tipp(state) {
      return state.tipp
    },
    verify_result(state) {
      return state.verify_result
    },
    audio_recognize(state) {
      return state.audio_recognize
    }
  },
  mutations: {
    clearModeState(state) {       
      state.satzes= []      
    },
    clearRegimeState(state) { 
      state.idMode0 = null, // Regime
      state.doNext = null,
      state.isFirstAnswer = true,    
      state.modeK = 1.0,
      state.isToRepeat = false,
      state.isToCheckVerb = false,
      state.progressMode = [],
      state.satz = {},
      state.tipp = {
        idSatz: null,
        tippMain: null,
        tippSatz: null,
        tippWords: [],
        tippVerbs: []
      },
      state.verify_result = {
        idSatz: null,
        result: null,
        verbsUnknown: [],
        resultWordsAnswerPerson: [],
        resultWordsAnswerRight: [],
        resultVerbsPlaceAnswerRight: []
      },
      state.audio_recognize = {
        idSatz: null,
        result: null,
      }            
    },
    updateSatzes(state, satzes) {
      state.satzes = satzes
    },
    setRegime(state, {idMode0}) {      
      state.idMode0 = idMode0;      
    },
    setDoNext(state, {doNext}) {      
      state.doNext = doNext;      
    },
    setIsFirstAnswer(state, {isFirstAnswer}) {      
      state.isFirstAnswer = isFirstAnswer;      
    },
    setModeK(state, {modeK}) {      
      state.modeK = modeK;      
    },
    setIsToRepeat(state, {isToRepeat}) {      
      state.isToRepeat = isToRepeat;      
    },
    setIsToCheckVerb(state, {isToCheckVerb}) {      
      state.isToCheckVerb = isToCheckVerb;      
    },    
    setProgressModeAndSatz(state, ProgressModeAndSatzId) {
      const satz = this.getters.satzes.find(element => {
        return element.id == ProgressModeAndSatzId.idSatz;
      });
      state.progressMode = ProgressModeAndSatzId.progressMode;
      state.satz = satz;
    },
    setTipp(state, tipp) {
      state.tipp = tipp;
    },
    setVerifyResult(state, verify_result) {
      state.verify_result = verify_result;
    },
    setAudioRecognize(state, audio_recognize) {
      state.audio_recognize = audio_recognize;
    },
  },
  actions: {
    async getCourseModeSatzes({ dispatch, commit }, { idUser, id }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeSatzes",
          pathVariable: null,
          data: { idUser, id }
        });
        if (objectResponse.bodyJson) {
          commit("updateSatzes", objectResponse.bodyJson)
        }
      } catch (e) { }
    },
    async getCourseModeRegimeProgress({ dispatch, commit }, { idUser, idMode0, idMode }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeRegimeProgress",
          pathVariable: null,
          data: { idUser, idMode0, idMode }
        });
        if (objectResponse.bodyJson) {
          return objectResponse.bodyJson.progressMode;
        }
      } catch (e) { }
    },
    async getCourseModeRegimeNextTask({ dispatch, commit }, { idUser, idMode0, idMode }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeRegimeNextTask",
          pathVariable: null,
          data: { idUser, idMode0, idMode }
        });
        if (objectResponse.bodyJson) {
          commit("setProgressModeAndSatz", objectResponse.bodyJson)
        }
      } catch (e) { }
    },
    async getCourseModeRegimeTipp({ dispatch, commit }, { idUser, id }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeRegimeTipp",
          pathVariable: null,
          data: { idUser, id }
        });
        if (objectResponse.bodyJson) {
          commit("setTipp", objectResponse.bodyJson)
        }
      } catch (e) { }
    },
    async getCourseModeRegimeVerifyResult({ dispatch, commit }, { idUser, idMode0, idMode, idSatz, answerPerson, modeK, isToRepeat, isToCheckVerb }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeRegimeVerifyResult",
          pathVariable: null,
          data: { idUser, idMode0, idMode, idSatz, answerPerson, modeK, isToRepeat, isToCheckVerb }
        });
        if (objectResponse.bodyJson) {
          commit("setVerifyResult", objectResponse.bodyJson)
        }
      } catch (e) { }
    },
    async getCourseModeRegimeAudioRecognize({ dispatch, commit }, { formData }) {
      try {
        const objectResponse = await dispatch("serverCall", {
          typeCall: "getCourseModeRegimeAudioRecognize",
          pathVariable: null,
          dataMultipartForm: formData
        });
        if (objectResponse.bodyJson) {
          commit("setAudioRecognize", objectResponse.bodyJson)
        }
      } catch (e) { }
    },
  }
}
